import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import {
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  TextField,
  List,
  ListItem,
  InputAdornment,
} from '@mui/material'

import ComboBox from '../../../../Components/ComboBox'
import CustomButton from '../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../utils/api'
import urls from '../../../../utils/urls'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import CreateDocument from './CreateDocument'
import AddIcon from '@mui/icons-material/Add'
import CreateCompany from '../CreateCompany'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { FixedSizeList as ListVirtualized } from 'react-window'
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
]

export default function CreateOperationForm({
  fetchdata,
  openFromUrl = false,
  defaultParcoursType = '',
  onUrlOpenConsumed = null,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  let w_experence = localStorage.getItem('w-experence')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [typeObject, setTypeObject] = useState(0)
  const [docId, setDocId] = useState(false)
  const [addCompay, setAddCompay] = useState(false)
  const [submit, setSubmit] = useState(false)
  const [companys, setCompanys] = useState([])
  const [competence, setCompetence] = useState([])
  const [getPays, setPays] = useState([])

  const [personName, setPersonName] = useState([])

  const [openDialog, setOpenDialog] = useState(false)
  const [selectedItems, setSelectedItems] = useState([])
  const [searchQuery, setSearchQuery] = useState('')

  const filteredItems = competence.filter((item) =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase()),
  )
  const handleOpenDialog = () => setOpenDialog(true)
  const handleCloseDialog = () => setOpenDialog(false)
  const handleCheckboxChange = (id) => {
    setSelectedItems((prevState) => {
      if (prevState.includes(id)) {
        return prevState.filter((selectedId) => selectedId !== id)
      }
      if (prevState.length < 5) {
        return [...prevState, id]
      }
      return prevState
    })
  }

  const renderRowCompetence = ({ index, style }) => {
    const item = filteredItems[index]
    return (
      <Box key={index} style={style}>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedItems.includes(item.id)}
              onChange={() => handleCheckboxChange(item.id)}
              disabled={selectedItems.length >= 5 && !selectedItems.includes(item.id)}
            />
          }
          label={item.label}
        />
      </Box>
    )
  }

  // {filteredItems.map((item, index) => (
  //   <ListItem key={index}>
  //     <FormControlLabel
  //       control={
  //         <Checkbox
  //           checked={selectedItems.includes(item.label)}
  //           onChange={() => handleCheckboxChange(item.label)}
  //           disabled={
  //             selectedItems.length >= 5 && !selectedItems.includes(item.label)
  //           }
  //         />
  //       }
  //       label={item.label}
  //     />
  //   </ListItem>
  // ))}
  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    // console.log(event.target)
    setPersonName(typeof value === 'string' ? value.split(',') : value)
  }

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      ParcoursType: '',
      Name: '',
      Entreprise: '',
      BeginDate: '',
      CurrentPoste: false,
      EndDate: null,
      KeyCompetencies: '',
      Country: '',
      City: '',
      ContractType: '',
      Statut: '',
      CollectiveAgre: '',
      GeneralInfo: '',
      TyHours: '',
      SubTHours: '',
      hours: null,
      docid: null,
      Gmsalary: '',
      GmsalaryF: '',
      FinancialArrangement: '',
      Advantage: '',
    },
  })

  const typeParcour = [
    { label: 'Formation', id: 1 },
    { label: 'Expérience', id: 2 },
  ]
  const gmsalaryF = [
    { label: 'Par heure', id: 1 },
    { label: 'Par jour', id: 2 },
    { label: 'Par semaine', id: 3 },
    { label: 'Par mois', id: 4 },
    { label: 'Par an', id: 5 },
  ]
  const contractType = [
    { label: 'CDI', id: 1 },
    { label: 'Indépendant', id: 2 },
    { label: 'Freelance', id: 3 },
    { label: 'CDD', id: 4 },
    { label: 'Stage', id: 5 },
    { label: 'Contrat en alternance', id: 6 },
    { label: 'Intermittent du spectacle', id: 7 },
    { label: 'CDI temps partiels', id: 8 },
    { label: 'Service civique', id: 9 },
    { label: 'CDD temps partiels', id: 10 },
    { label: 'VIA / VIE', id: 11 },
    { label: 'Fonctionnaire', id: 12 },
    { label: 'Intérimaire', id: 13 },
  ]
  useEffect(() => {
    fetchPays()
    if (w_experence) {
      handleClickOpen()
    }
  }, [])

  useEffect(() => {
    if (!openFromUrl) return

    handleClickOpen()
    if (defaultParcoursType === 'Expérience') {
      setTypeObject(2)
      setValue('ParcoursType', { label: 'Expérience', id: 2 })
    } else if (defaultParcoursType === 'Formation') {
      setTypeObject(1)
      setValue('ParcoursType', { label: 'Formation', id: 1 })
    }
    if (onUrlOpenConsumed) onUrlOpenConsumed()
  }, [openFromUrl, defaultParcoursType, onUrlOpenConsumed, setValue])

  const handleClickOpen = () => {
    setOpen(true)
    setTypeObject(0)
    fetchCompanys()
    fetchCompetence()
    setSubmit(false)
  }

  const allowSubmit = () => {
    setSubmit(true)
  }
  const handleClose = () => {
    setOpen(false)
    reset()
    setTypeObject(0)
    setPersonName([])
    setDocId(false)
    setSubmit(false)
  }

  const onSubmitPar = async (data) => {
    if (submit) {
      let payload = {}
      // let val = []
      // selectedItems.forEach((n) => {
      //   let i = competence.filter((v) => v.id === n)
      //   val.push(i[0].id)
      // })

      payload = {
        ...data,
        Country: data.Country.id,
        Entreprise: data.Entreprise.id,
        ParcoursType: data.ParcoursType.label,
        KeyCompetencies: selectedItems,
        docid: docId ? docId.id : null,
      }
      if (!data.EndDate) {
        delete payload['EndDate']
      }

      const response = await makePostRequest(urls.crudParcoursProOperations, payload, {}, true)
      if (response.status === 201) {
        fetchdata()
        handleClose()
        if (w_experence) {
          await makePostRequest(
            '/api/app/user-wizard/',
            { step: w_experence, completed: true, skip: true },
            {},
            true,
          )

          dispatch(setUserWizardDone({ step: w_experence, completed: true, skip: false }))
          let w_f_count = localStorage.getItem('w_f_count')
          let w_e_count = localStorage.getItem('w_e_count')
          if (data.ParcoursType.id === 1) {
            if (w_f_count) {
              w_f_count = parseInt(w_f_count) + 1
              localStorage.setItem('w_f_count', w_f_count)
            } else {
              localStorage.setItem('w_f_count', 1)
              w_f_count = 1
            }
          } else {
            if (!w_f_count) w_f_count = 0
          }
          if (data.ParcoursType.id === 2) {
            if (w_e_count) {
              w_e_count = parseInt(w_e_count) + 1
              localStorage.setItem('w_e_count', w_e_count)
            } else {
              w_e_count = 1
              localStorage.setItem('w_e_count', 1)
            }
          } else {
            if (!w_e_count) w_e_count = 0
          }
          let mssg = ''

          localStorage.setItem(
            't_message',
            `Vous avez ajouté ${w_e_count} expérience${
              w_e_count > 1 ? 's' : ''
            }.<br/> Vous avez ajouté ${w_f_count} formation${w_f_count > 1 ? 's' : ''}."`,
          )
          localStorage.removeItem('w-experence')
          navigate('/')
        }
      }
    }
  }
  const fetchCompanys = async () => {
    const url = urls.fetchCompanys + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Name}`, id: v.id })
      })
      setCompanys([...filterTypes])
    }
  }

  const fetchCompetence = async () => {
    const url = urls.fetchCompetence + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.CompetencesName}`, id: v.id })
      })
      setCompetence([...filterTypes])
    }
  }

  const fetchPays = async () => {
    const url = '/api/Social/get-countries/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPays = []
      data.forEach((v) => {
        filterPays.push({ label: `${v.CountryCode}/${v.Designation}`, id: v.id })
      })
      setPays([...filterPays])
    }
  }

  const clearData = () => {
    setSubmit(false)
    reset()
    setPersonName([])
    setDocId(false)
  }
  return (
    <>
      {addCompay && (
        <CreateCompany
          fetchCompanys={fetchCompanys}
          setAddCompay={setAddCompay}
          headerText={typeObject === 1 ? 'Entreprise' : 'Organisation'}
        />
      )}
      {isMobile ? (
        <AddCircleIcon onClick={handleClickOpen} />
      ) : (
        <CustomButton onClick={handleClickOpen}>{t('parcoursPro.btnAdd') /* LAP-733 (GE022) */}</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: '#202020' }}>{t('parcoursPro.dialogTitle') /* LAP-733 (GE022) */}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmitPar)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                if (j.id === 1) {
                  clearData()
                  setTypeObject(1)
                } else if (j.id === 2) {
                  clearData()
                  setTypeObject(2)
                }
                setValue('ParcoursType', j)
              }}
              label="Type de parcours"
              data={typeParcour}
              name="ParcoursType"
              required={true}
            />
            {typeObject === 1 ? (
              <>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  rules={{ required: true }}
                  name="Name"
                  label="Intitulé poste ou formation (Name)"
                />
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Box sx={{ width: '100%' }}>
                    <ComboBox
                      handleAutoComplete={(e, j) => {
                        setValue('Entreprise', j)
                      }}
                      label="Organisation"
                      data={companys}
                      name="Entreprise"
                      required={true}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: '30px',
                      marginTop: '12px',
                      display: 'flex',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      paddingX: '5px',
                    }}
                    onClick={() => setAddCompay(true)}
                  >
                    <AddIcon />
                  </Box>
                </Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'date',
                    required: true,
                    size: 'small',
                  }}
                  InputLabelProps={{ shrink: true }}
                  rules={{ required: true }}
                  name="BeginDate"
                  label="Date de début"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => {
                        setValue('CurrentPoste', e.target.checked)
                      }}
                    />
                  }
                  label="Je fais cette formation actuellement"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'date',
                    // required: false,
                    size: 'small',
                  }}
                  InputLabelProps={{ shrink: true }}
                  // rules={{ required: false }}
                  name="EndDate"
                  label="Date de fin"
                />
                <TextField
                  sx={{ mb: 2 }}
                  label="Compétences clés"
                  fullWidth
                  size="small"
                  onClick={handleOpenDialog}
                  value={selectedItems
                    .map((id) => competence.find((item) => item.id === id)?.label)
                    .join(', ')}
                  // value={selectedItems.join(', ')}
                  readOnly
                />

                <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
                  <DialogTitle color={'black !important'}>Select Compétences clés</DialogTitle>
                  <DialogContent>
                    <TextField
                      sx={{ mt: 2 }}
                      label="Search"
                      fullWidth
                      size="small"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">🔍</InputAdornment>,
                      }}
                    />
                    <ListVirtualized
                      height={400}
                      itemCount={filteredItems.length}
                      itemSize={50}
                      width="100%"
                    >
                      {renderRowCompetence}
                    </ListVirtualized>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                      Annuler
                    </Button>
                    <Button
                      onClick={handleCloseDialog}
                      color="primary"
                      disabled={selectedItems.length === 0}
                    >
                      Valider
                    </Button>
                  </DialogActions>
                </Dialog>
                {/* <FormControl sx={{ width: '-webkit-fill-available' }}>
                  <InputLabel id="competences-cles">Compétences clés</InputLabel>
                  <Select
                    labelId="competences-cles"
                    id="cles-multiple-checkbox"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Compétences clés" />}
                    renderValue={(selected) => selected.join(', ')}
                    sx={{
                      '& #cles-multiple-checkbox': {
                        padding: '10px 14px',
                      },
                    }}
                  >
                    {competence.map((v) => (
                      <MenuItem key={v.id} value={v.label}>
                        <Checkbox checked={personName.indexOf(v.label) > -1} />
                        <ListItemText primary={v.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}
                <ComboBox
                  handleAutoComplete={(e, j) => setValue('Country', j)}
                  label="Pays"
                  data={getPays}
                  name="Country"
                  // required={true}
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  // rules={{ required: true }}
                  name="City"
                  label="Ville"
                />
              </>
            ) : (
              ''
            )}
            {typeObject === 2 ? (
              <>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Box sx={{ width: '100%' }}>
                    <ComboBox
                      handleAutoComplete={(e, j) => {
                        setValue('Entreprise', j)
                      }}
                      label="Entreprise"
                      data={companys}
                      name="Entreprise"
                      required={true}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: '30px',
                      marginTop: '12px',
                      display: 'flex',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      paddingX: '5px',
                    }}
                    onClick={() => setAddCompay(true)}
                  >
                    <AddIcon />
                  </Box>
                </Box>

                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  rules={{ required: true }}
                  name="Name"
                  label="Intitulé poste ou formation (Name)"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'date',
                    required: true,
                    size: 'small',
                  }}
                  InputLabelProps={{ shrink: true }}
                  rules={{ required: true }}
                  name="BeginDate"
                  label="Date de début"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => {
                        setValue('CurrentPoste', e.target.checked)
                      }}
                    />
                  }
                  label="J'occupe cette fonction actuellement "
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'date',
                    // required: false,
                    size: 'small',
                  }}
                  InputLabelProps={{ shrink: true }}
                  // rules={{ required: false }}
                  name="EndDate"
                  label="Date de fin"
                />
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setValue('ContractType', j.label)
                  }}
                  label="Type de contrat"
                  data={contractType}
                  name="ContractType"
                  // required={true}
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  // rules={{ required: true }}
                  name="Statut"
                  label="Statut"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  // rules={{ required: true }}
                  name="CollectiveAgre"
                  label="Convention collective"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    // size: 'small',
                    type: 'text',
                  }}
                  rows={4}
                  multiline
                  // rules={{ required: true }}
                  name="GeneralInfo"
                  label="Desrciption"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  // rules={{ required: true }}
                  name="TyHours"
                  label="Type d'horaire"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  // rules={{ required: true }}
                  name="SubTHours"
                  label="Sous type horaire"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'number',
                  }}
                  // rules={{ required: true }}
                  name="hours"
                  label="Chiffre horaire"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'number',
                  }}
                  // rules={{ required: true }}
                  name="Gmsalary"
                  label="Salaire Brut"
                />
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setValue('GmsalaryF', j.label)
                  }}
                  label="Base frequence salaire brut"
                  data={gmsalaryF}
                  name="GmsalaryF"
                  // required={true}
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'number',
                  }}
                  // rules={{ required: true }}
                  name="FinancialArrangement"
                  label="Prime, variable"
                />
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  rows={4}
                  multiline
                  // rules={{ required: true }}
                  name="Advantage"
                  label="Advantage"
                />

                <TextField
                  sx={{ mb: 2 }}
                  label="Compétences clés"
                  fullWidth
                  size="small"
                  onClick={handleOpenDialog}
                  value={selectedItems
                    .map((id) => competence.find((item) => item.id === id)?.label)
                    .join(', ')}
                  // value={selectedItems.join(', ')}
                  readOnly
                />

                <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
                  <DialogTitle color={'black !important'}>Select Compétences clés</DialogTitle>
                  <DialogContent>
                    <TextField
                      sx={{ mt: 2 }}
                      label="Search"
                      fullWidth
                      size="small"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">🔍</InputAdornment>,
                      }}
                    />
                    <ListVirtualized
                      height={400}
                      itemCount={filteredItems.length}
                      itemSize={50}
                      width="100%"
                    >
                      {renderRowCompetence}
                    </ListVirtualized>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                      Annuler
                    </Button>
                    <Button
                      onClick={handleCloseDialog}
                      color="primary"
                      disabled={selectedItems.length === 0}
                    >
                      Valider
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* <FormControl sx={{ width: '-webkit-fill-available' }}>
                  <InputLabel id="competences-cles">Compétences clés</InputLabel>
                  <Select
                    labelId="competences-cles"
                    id="cles-multiple-checkbox"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Compétences clés" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                    sx={{
                      '& #cles-multiple-checkbox': {
                        padding: '10px 14px',
                      },
                    }}
                  >
                    <Box>
                      <Box>Title</Box>
                      <Box>
                        {competence.map((v) => (
                          <MenuItem key={v.id} value={v.label}>
                            <Checkbox checked={personName.indexOf(v.label) > -1} />
                            <ListItemText primary={v.label} />
                          </MenuItem>
                        ))}
                      </Box>
                    </Box>
                  </Select>
                </FormControl> */}
              </>
            ) : (
              ''
            )}

            {/* <CustomButton onClick={handleClickOpen}>{'>'}-Ajouter document</CustomButton> */}
            <CreateDocument setDocId={setDocId} setSubmit={setSubmit} />
            {docId && (
              <Typography
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontStyle: 'italic',
                }}
              >
                {docId.Nom}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={allowSubmit} type="submit">
              Valider
            </Button>
            <Button
              onClick={() => {
                handleClose()
                if (w_experence) {
                  localStorage.removeItem('w-experence')
                  navigate('/')
                }
              }}
            >
              Annuler
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
